import $ from "jquery";

function focusErrorElement(formElement: HTMLFormElement) {
    const $form = $(formElement);
    const $lcContainerContent = $form.closest(".lc-container__content");

    //Find the first element within the current content, which has the "input validation error" class active
    const errorDiv = $form.find(".input-validation-error:visible").first();

    if (errorDiv != undefined) {
        const errorDivElement = errorDiv[0];

        if (errorDivElement != undefined) {
            //Get the id of the element && check for a label
            const labelElement = $("label[for='" + $(errorDivElement).attr("id") + "']")[0];

            //If a label is found scroll to the label, else scroll to the element with the input validation error class
            let offset;

            if (labelElement != undefined) {
                offset = getOffset(labelElement, $lcContainerContent);
            } else {
                offset = getOffset(errorDivElement, $lcContainerContent);
            }

            $(errorDivElement).focus();
            $lcContainerContent.scrollTop(offset);
        }
    }
}

function getOffset(containingElement: HTMLElement, $container: JQuery<Element>) {
    if ($container === undefined || $container.offset() === undefined) return $(containingElement).offset().top;
    else return $(containingElement).offset().top - $container.offset().top + $container.scrollTop();
}

export default {
    focusErrorElement: focusErrorElement
};
